import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import customConfirmationDecisionMagazine from "../../../../src/content/pray-for-president/customConfirmationDigitalcopy";
import "../../../../src/content/pray-for-president/pray-president.scss";
import * as React from 'react';
export default {
  NewNamesForm,
  customConfirmationDecisionMagazine,
  React
};